module.exports = __webpack_public_path__ + "static/img/dsk-home-bg1.20b27b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-home-bg1.jpg
// module id = 231
// module chunks = 1